export default __webpack_public_path__ + "static/media/coc.34719597.jpg";